import produce from 'immer';
import { useState, useRef } from 'react';

import { fetchBackend } from '../fetch-backend';

export const StagesList = {
  Initial: 0,
  Stars: 1,
  SubmittingStars: 2,
  Discount: 3,
  GettingDiscount: 4,
  ThankYou: 5,
};
export const ResponseCodes = {
  AlreadySubmitted: '-1',
  UndefinedError: '0',
  Success: '1',
};

export const useStepper = () => {
  const submittingStarsRef = useRef(false);
  const gettingTheDiscountRef = useRef(false);
  const [workflow, setWorkFlow] = useState({
    stage: StagesList.Initial,
    responseCodes: {
      submitStars: null,
      getTheDiscount: null,
    },
  });
  const [customerName, setCustomerName] = useState('');
  const [email, setEmail] = useState('');
  const [source, setSource] = useState('');
  const [checked, setChecked] = useState(false);
  const [stars, setStars] = useState(0);
  const handleCustomerNameChange = (event) => {
    setCustomerName(event.target.value);
  };
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };
  const handleSourceChange = (event) => {
    setSource(event.target.value);
  };
  const toggleChecked = () => {
    setChecked((prev) => !prev);
  };
  const toStarsStage = (event) => {
    event.preventDefault();
    setWorkFlow(
      produce((draft) => {
        draft.stage = StagesList.Stars;
      })
    );
  };
  const fetchAddCustomer = (withGetBonus) =>
    fetchBackend('/api/v1/addCustomer', {
      method: 'POST',
      body: JSON.stringify({
        customerName,
        email,
        source,
        stars,
        ...(withGetBonus ? { getBonus: true } : {}),
      }),
      headers: { 'Content-Type': 'application/json' },
    });
  const submitStars = async (event) => {
    event.preventDefault();
    if (!submittingStarsRef.current) {
      submittingStarsRef.current = true;
      if (stars <= 3) {
        // Intentionally not waiting for a response from the backend
        fetchAddCustomer(false);
        setWorkFlow(
          produce((draft) => {
            draft.stage = StagesList.Discount;
          })
        );
      } else {
        setWorkFlow(
          produce((draft) => {
            draft.stage = StagesList.SubmittingStars;
          })
        );
        const response = await fetchAddCustomer(false);
        setWorkFlow(
          produce((draft) => {
            draft.responseCodes.submitStars = response.code;
            if (response.code === ResponseCodes.Success) {
              draft.stage = StagesList.Discount;
            }
          })
        );
      }

      submittingStarsRef.current = false;
    }
  };
  const getTheDiscount = async (event) => {
    event.preventDefault();
    if (!gettingTheDiscountRef.current) {
      gettingTheDiscountRef.current = true;
      setWorkFlow(
        produce((draft) => {
          draft.stage = StagesList.GettingDiscount;
        })
      );
      const response = await fetchAddCustomer(true);
      setWorkFlow(
        produce((draft) => {
          draft.responseCodes.getTheDiscount = response.code;
          if (response.code === ResponseCodes.Success) {
            draft.stage = StagesList.ThankYou;
          }
        })
      );
      gettingTheDiscountRef.current = false;
    }
  };
  const handleStars = (_event, value) => {
    setStars(value);
  };

  return {
    sourcesList: [
      'Website',
      'Amazon',
      'Walmart',
      'Home Depot',
      'Catch',
      'OnBuy',
      'Real',
      'Other',
    ],
    stepsList: ['Step 1', 'Step 2', 'Step 3'],
    starsList: ['Poor', 'Fair', 'Average', 'Good', 'Excellent'],
    stage: workflow.stage,
    responseCodes: workflow.responseCodes,
    customerName,
    email,
    source,
    checked,
    stars,
    handleCustomerNameChange,
    handleEmailChange,
    handleSourceChange,
    toggleChecked,
    toStarsStage,
    handleStars,
    submitStars,
    getTheDiscount,
  };
};
